import React from 'react';

import { formatMoney } from '@betterment/core';
import { Separator } from '@betterment/samba-react';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../../graphql/fragments/activityItem.generated';
import { ActivityItemStage } from '../../../../../graphql/schema';
import { NarrowTypename } from '../../../../../graphql/utils/narrow-typename';
import { ActivityDrawerLayout } from '../common/ActivityDrawerLayout';
import { ActivityReportsUrl } from '../common/ActivityReportsUrl';
import { StatusSection } from '../common/StatusSection';
import { TradesList } from '../common/trades/TradesList';

export const Transfer: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemTransferGroup'>;
}> = ({ item }) => {
  const isCanceled = item.statuses[item.statuses.length - 1].stage === ActivityItemStage.Canceled;
  const { users } = item.subAccount;
  return (
    <ActivityDrawerLayout title="Transfer" users={users}>
      <DrawerListRow label="From" value={item.transferSourceAccount?.name ?? ''} />
      <Separator />
      <DrawerListRow label="To" value={item.transferDestinationAccount?.name ?? ''} />
      <Separator />
      {item.amount && (
        <>
          {item.isFullTransfer ? (
            <>
              <DrawerListRow label="Requested amount" value="Full amount" />
              <DrawerListRow label="Final amount" value={formatMoney(item.amount)} />
            </>
          ) : (
            <DrawerListRow label="Amount" value={formatMoney(item.amount)} shouldLineThrough={isCanceled} />
          )}
          <Separator />
        </>
      )}
      <StatusSection statuses={item.statuses} />
      {item.transferItems.length > 0 && (
        <>
          <Separator />
          <TradesList
            title="Transfer details"
            items={item.transferItems}
            toolTipMessage="We transferred your assets with minimal selling to help reduce taxes and keep your money invested."
          />
        </>
      )}
      <Separator />
      {item.activityReportsUrl && (
        <>
          <Separator />
          <ActivityReportsUrl url={item.activityReportsUrl} />
        </>
      )}
    </ActivityDrawerLayout>
  );
};
